import type { MONDAY_TYPES } from "@onesolution/monday";
import { gql } from "graphql-request";
import { requestAndFormat } from "../utils";

export const boardsFromClientWorkspaceQuery = (context: {
	user: { monday_workspace_id: string };
}) =>
	requestAndFormat({
		defaultParams: {
			workspaceId: context.user.monday_workspace_id,
		},
		gql: gql`
			query GetBoardsFromClientWorkspace($workspaceId: ID!) {
				boards(workspace_ids: [$workspaceId], limit: 500, hierarchy_types: [classic, multi_level]) {
				id
				name
				}
			}`,
		resultKey: "boards",
		outType: [] as Array<MONDAY_TYPES["base"]>,
	});
